import React, { useContext } from 'react'
import { successToast, ToastContext } from 'components/Toast/Toast'
import { useApiClient } from 'utils/api/ApiClient'
import { PartnershipsApiClient } from 'utils/api/partnershipsApi'

import {
  CreateIntroducingBrokerProfileForm,
  IntroducingBrokerProfileFormValues,
} from './CreateIntroducingBrokerProfileForm'

interface InnerProps {
  onClose(): void
}

const CreateIntroducingBrokerProfilePage: React.FC<InnerProps> = ({ onClose }) => {
  const setToast = useContext(ToastContext)
  const partnershipsApiClient = useApiClient(PartnershipsApiClient)

  const onSubmit = async (values: IntroducingBrokerProfileFormValues) => {
    try {
      await partnershipsApiClient.createIntroducingBrokerProfile(values)
      setToast(successToast('Introducing Broker Profile created successfully.'))
      onClose()
    } catch (e) {
      console.error(e)
    }
  }

  return <CreateIntroducingBrokerProfileForm onSubmit={onSubmit} />
}

export default CreateIntroducingBrokerProfilePage
